import React from 'react';
import { Input } from 'semantic-ui-react';

function InputCheckbox({ ...props }) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Input type="checkbox" className="flex flex-col" {...props} />;
}

export default React.memo(InputCheckbox);
